import { Navigate } from 'react-router-dom';
import { useCurrentRole } from '@/stores/authStore';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
}

export default function RoleProtectedRoute({
  children,
  allowedRoles,
  redirectTo = '/dashboard'
}: RoleProtectedRouteProps) {
  const currentRole = useCurrentRole();

  // If no role or role not allowed, redirect
  if (!currentRole || !allowedRoles.includes(currentRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
